<template>
  <div id="exam">
      <el-button size="mini" class="btn" @click="visibilityInfo=true" >查看题目</el-button>
      <el-button size="mini" style="margin-left:0" class="btn" @click="onSubmit" type="danger">提交题目</el-button>
      <div class="time">{{time}}</div>
     <el-dialog
            :title="info.name"
            :visible.sync="visibilityInfo"
            width="50%"
            v-if="visibilityInfo"
            append-to-body
            >
            <p v-html="info.detail"></p>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="visibilityInfo = false">关闭</el-button>
            </span>
    </el-dialog>
        <result append-to-body title="考试已经结束" subTitle="考试已经结束，您可以选择提交题目或者关闭当前答题" v-if="isEnd">
            <el-button  size="small" @click="visibilityInfo = true">查看题目</el-button> 
            <el-button  size="small" type="danger" @click="onCloseWindow">关闭答题</el-button>   
            <el-button size="small" type="primary" @click="onSubmit">提交答题</el-button>   
        </result>  
  </div>
</template>

<script>
import { mapState } from "vuex";
import { info, save } from '@/api/exam'
import Result from './Result'
export default {
    components: {Result},
  data() {
    return {
        info: {},
        loadSb3:{},
        time: '00:00:00',
        isEnd: false,
        startTime: new Date().getTime(),
        timer:0,
        visibilityInfo: false
    };
  },
  computed: {
    ...mapState({
      state: (state) => state.info,
    }),
  },
  created() {
      this.handleInitTime()
  },
  mounted(){
  },
  methods:{
      // 关闭当前窗口
      onCloseWindow(){
        this.$confirm('确定要关闭窗口吗？','温馨提示',{type: 'warning'}).then(res=>{
            window.close()
        })
      },
      // 提交答题
      onSubmit(){
          this.$emit('handleGetSb3Url',this.info.name, url=>{
              console.log('地址：',url)
              save({
                answerOption:url,
                coverImg: 'https://s.mamale.vip/2020/09/22/21b9d37247a249e8fb5839f7c760deb5.jpeg',
                subjectId: this.state.examSubjectId,
                examStudentId: this.state.examId
              }).then(res=>{
                   this.$message({
                            message: '恭喜你，提交成功！',
                            type: 'success'
                        });
              })
          })    
      },
      // 初始化考试
      handleInitExam(){
          info(this.state.examId).then(res=>{
            let subjectInfo = {}
            let loadFile = false
            res.subjects.forEach(subject=>{
                if(subject.id == this.state.examSubjectId){
                    subjectInfo = subject
                    loadFile = subjectInfo.items
                    this.info = subject
                    this.base = subjectInfo.items
                   
                }
            })
            res.examStudentAnswers.forEach(item=>{
                if(item.subjectId === subjectInfo.id){
                    loadFile = item.answerOption
                }
            })
            // 基础python 文件
            if(loadFile!==false){
                // TODO 加载python 文件
                this.$emit('handleLoadProject',loadFile)
            }
            const endTime =   new Date(res.limitEndTime).getTime()
            const timeInterval = () => {
                    const time = this.startTime - -1000
                    const diffTime = parseInt((endTime - time) / 1000)
                    if(diffTime<0){
                        clearInterval(this.timer)
                        this.timer = false
                        this.time = `00:00:00`
                        this.isEnd = true
                        return
                    }
                    const s = parseInt(diffTime % 60) < 10 ? '0' + parseInt(diffTime % 60) : parseInt(diffTime % 60)
                    const m = parseInt(diffTime / 60 % 60) < 10 ? '0' + parseInt(diffTime / 60 % 60) : parseInt(diffTime / 60 % 60)
                    const h = parseInt(diffTime / 60 / 60 % 60) < 10 ? '0' + parseInt(diffTime / 60 / 60 % 60) : parseInt(diffTime / 60 / 60 % 60)
                    this.time =  `${h}:${m}:${s}`
                    this.startTime = time
            }
            this.timer = setInterval(timeInterval, 1000)
            timeInterval()
        })
      },
     
      // 初始化时间
      handleInitTime(){
        fetch('https://api.mamale.vip/api/app/exam/pCurrentDateTime').then(res=>{
          res.text().then(value=>{
              this.startTime = new Date(value.replace(/\"/g,'')).getTime()
            console.log(this.startTime)
              this.handleInitExam()
            })
        })
      }
  }
};
</script>

<style lang="less" scoped>
#exam{
    display: inline-block;
    height: 100%;
    vertical-align: top;
    .end{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999999999999;
    }
    .btn{
        margin: 12px 20px;
    }
    .time{
        display: inline-block;
         background: red;
        color: white;
        padding: 5px 10px;
        right: 234px;
        border-radius: 5px;
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Exam.vue